export interface TablePage<T> {
  items: T[];
  /** Discard previously accumulated rows before applying this page. */
  reset?: boolean;
}

export function mergeTablePage<T>(current: T[], page: TablePage<T>): T[] {
  return page.reset ? [...page.items] : [...current, ...page.items];
}

export function collectTableRows<T>(pages: TablePage<T>[]): T[] {
  let start = 0;
  for (const [index, page] of pages.entries()) {
    if (page.reset) {
      start = index;
    }
  }
  return pages.slice(start).flatMap((page) => page.items);
}
